import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	menuItemLoading: {
		id: 'navigation.universal-create.menuItemLoading',
		defaultMessage: 'Menu item is loading',
		description: 'The message that screen reader announces when a menu item is loading',
	},
});

export default messages;
